import { createRouter } from "./app/router.ts";
import { appRoutes } from "./app/routes/registry.ts";
import { createShell } from "./app/shell.ts";
import { ShellState } from "./app/state.ts";
import "./design-system/styles/index.css";

/**
 * Application entry point.
 *
 * Everything below is composition: build the shell, register routes, start the
 * router. No security decision, no bank contact and no persistence happens
 * here or anywhere it reaches.
 */

const mount = document.getElementById("nura-root");
if (mount === null) throw new Error("missing #nura-root mount point");

const state = new ShellState();
state.apply();

// The resolved theme changes when the OS preference changes and the choice is
// "system", which the tenant's brand tokens have to follow.
window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
  if (state.theme === "system") state.apply();
});

const shell = createShell(state);
mount.replaceChildren(shell.root);

createRouter({
  routes: appRoutes(state),
  outlet: shell.outlet,
  fallback: "/",
  titleSuffix: "Nura",
  // A route that renders a bank's own surface as the whole page says so, and
  // the shell steps out of the way — app bar, banner and footer included.
  onNavigate: (route) => {
    shell.root.dataset["chrome"] = route.chrome ?? "full";
  },
}).start();
